import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect } from "react";
import { useFormikContext } from "formik";
import { isMobile } from "../is-mobile";
const SCROLLABLE_ERROR_AREA_ID = "scrollableArea";
/**
 * Prefix error messages elements id attribute with this string in order to scroll to them.
 */
export const SCROLLABLE_ERROR_ID = "error-field-scroll-target";
export const ScrollToError = ({ offsetTop, offsetBottom, scrollTopOffset, elementSelector, }) => {
    const { submitCount } = useFormikContext();
    useEffect(() => {
        requestAnimationFrame(() => {
            scrollToFirstErrorIfAny(offsetTop, offsetBottom, scrollTopOffset, elementSelector);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submitCount]);
    return null;
};
ScrollToError.defaultProps = {
    offsetTop: 0,
    offsetBottom: 0,
    // address top menu bar offset on iPhone
    scrollTopOffset: isMobile ? 200 : 100,
};
/**
 * Use this area as container for your form where errors are expected.
 */
export const ScrollableErrorArea = forwardRef((props, ref) => (_jsx("div", { ref: ref, ...props, "data-test-id": SCROLLABLE_ERROR_AREA_ID })));
/**
 * Helpers
 */
const isInViewport = (el, offsetTop, offsetBottom) => {
    const rect = el.getBoundingClientRect();
    return (rect.top >= offsetTop &&
        rect.left >= 0 &&
        rect.bottom <=
            (window.innerHeight - offsetBottom ||
                document.documentElement.clientHeight - offsetBottom) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth));
};
const isNotInViewport = (el, offsetTop, offsetBottom) => isInViewport(el, offsetTop, offsetBottom) === false;
const scrollToFirstErrorIfAny = (offsetTop, offsetBottom, scrollTopOffset, elementSelector = `[data-test-id=${SCROLLABLE_ERROR_AREA_ID}]`) => {
    const pagerElement = document.querySelector(elementSelector);
    // Search within the parent element children - fix for confirmation modal blocks
    const errorElements = (pagerElement ?? document).querySelectorAll(`[id^="${SCROLLABLE_ERROR_ID}"]`);
    const targetErrorElement = Array.from(errorElements).find(element => isNotInViewport(element, offsetTop, offsetBottom));
    if (pagerElement && targetErrorElement) {
        scrollParentToChild(pagerElement, targetErrorElement, scrollTopOffset);
    }
};
const scrollParentToChild = (parentEl, childEl, scrollTopOffset) => {
    parentEl.scrollTop = childEl.offsetTop - parentEl.offsetTop - scrollTopOffset;
};
